import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

function Home() {
  const history = useHistory();

  // Antes el push vivia en el onClick pero se ejecutaba al renderizar; la
  // portada sigue mandando al login, ahora sin el efecto colateral.
  useEffect(() => {
    history.push("/login");
  }, [history]);

  return (
    <div className="inicio-portada">
      <img
        src={process.env.PUBLIC_URL + "/logoInstitucion.png"}
        alt="Cavanna Mezclilla"
        className="inicio-logo"
      />
    </div>
  );
}

export default Home;
